export default "__VITE_ASSET__CyV8uNGS__"